export const currency = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  maximumFractionDigits: 0,
});

// Dates are shown in the property's time zone, not the device's (must match backend PROPERTY_TIMEZONE).
// Stay dates arrive as UTC midnight, which is still the same calendar day in IST.
export const PROPERTY_TIME_ZONE = "Asia/Kolkata";

export const shortDate = (value: string) =>
  new Intl.DateTimeFormat("en-IN", { day: "numeric", month: "short", timeZone: PROPERTY_TIME_ZONE }).format(new Date(value));

// Today's date (YYYY-MM-DD) at the property - toISOString() would give the UTC date, a day behind before 05:30 IST.
export const todayIso = (now = new Date()) =>
  new Intl.DateTimeFormat("en-CA", { year: "numeric", month: "2-digit", day: "2-digit", timeZone: PROPERTY_TIME_ZONE }).format(now);

export const initials = (name = "User") =>
  name.split(/\s+/).map((part) => part[0]).join("").slice(0, 2).toUpperCase();

export const timeAgo = (value: string) => {
  const seconds = Math.max(0, Math.floor((Date.now() - new Date(value).getTime()) / 1000));
  if (seconds < 60) return "Just now";
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d ago`;
  return shortDate(value);
};

// The front desk's working day (YYYY-MM-DD): before the property's late-arrival cutoff it is still yesterday,
// so a 2 AM arrival belongs to last night's booking. Mirrors propertyBusinessDate on the server.
export const businessDateIso = (cutoff = "06:00", now = new Date()) => {
  const time = new Intl.DateTimeFormat("en-GB", { hour: "2-digit", minute: "2-digit", hourCycle: "h23", timeZone: PROPERTY_TIME_ZONE }).format(now);
  return time < cutoff ? todayIso(new Date(now.getTime() - 86_400_000)) : todayIso(now);
};
